import * as React from "react";
const SvgGridDesign20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 1h16v2.964l-1.5-1.5-.536.536H10v4.964L7.964 10H3v4h1.546l-.02.146L4.26 16H1V1Zm2 7h5V3H3v5Zm13.207-2.707-.707-.707-.707.707-8.5 8.5-.236.236-.047.33-.5 3.5-.189 1.32 1.32-.19 3.5-.5.33-.046.236-.236 8.5-8.5.707-.707-.707-.707-3-3ZM7.68 16.822l.264-1.85L15.5 7.413 17.086 9l-7.557 7.557-1.85.265Z",
      clipRule: "evenodd"
    })
  );
export default SvgGridDesign20Px;
